
<template>
  <div>
    <div id="admin-preloader" v-if="loading">
      <div id="admin-loader-text">Loading</div>
      <div id="admin-loader"></div>
    </div>
    <div v-if="changed">
      <!-- <h3 class="m-auto text-info text-center pt-3 pb-3">Let's Start</h3> -->
      <div class="container">
        <!-- <div class="row">
    <div class="col-12 col-md-8 mx-auto my-4 bg-white">
      <form-wizard finish-button-text="Go to Setting" color="#6A55C2" @on-complete="onComplete">
        <h2 slot="title" class="text-info">Let's Start</h2> 
  <tab-content title="">
    <h4 class="text-info mb-2">Step 1</h4> 
     <h6 class="text-secondary mb-2">Go to Home Page and add a banner image of your shop.</h6>
      <h6 class="text-secondary mb-2">Then go to About Page, Here you can write a description about your shop. Also you can add an image of your team or your shop.</h6>
  </tab-content>
  <tab-content title="">
     <h4 class="text-info mb-2">Step 2</h4> 
       <h4 class="text-info mb-2">Settig Up Contact Details</h4> 
       <h6 class="text-secondary mb-2">Go to Contact Page and add the contact details of your shop.</h6>
        
   </tab-content>
   <tab-content title="">
      <h4 class="text-info mb-2">Step 3</h4>
       <h4 class="text-danger mb-2">Important!!!</h4>  
       <h6 class="text-secondary mb-2">In order to add items/products, you need to go to <router-link :to="{name:'adminsetting'}"> Setting </router-link> and enter your Project Id as shown there.</h6>

       <div v-if="plan == 'Starter'">
       <h6 v-if="plan == 'Starter'" class="text-secondary mb-2">After this done, you can add items and offers to your <span class="text-dark">eshop.</span></h6>
        <h6 class="text-secondary mb-2" v-if="items == 10">Please make sure to add minimum of {{items}} items/products in order to show your shop in the search results.</h6>
         <h6 class="text-secondary mb-2" v-if="items == 5">Please make sure to add minimum of {{items}} vehicles in order to show your shop in the search results.</h6>
       </div>
       
       <div v-if="plan != 'Starter'">
       <h6 class="text-secondary mb-2">After this done, you can add items and offers to your <span class="text-dark">eshop</span>, receive orders from customers and deliver items to them. </h6>
         <h6 class="text-secondary mb-2" v-if="items == 10">Please make sure to add minimum of {{items}} items/products in order to show your shop in the search results.</h6>
         <h6 class="text-secondary mb-2" v-if="items == 5">Please make sure to add minimum of {{items}} vehicles in order to show your shop in the search results.</h6>
         </div>
       <h6 class="text-secondary mb-2">Feel free to contact us anytime, if you have any inconvenience or need more information.</h6>

       <h4 class="text-danger mb-2">Rock Your Business - <span>Regards from eshops.lk</span></h4>  
      
   </tab-content>
</form-wizard>
</div>
</div> -->
        <!-- <h2 class="m-auto text-dark text-center mt-3 pb-2">Current Status</h2> -->

        <div v-if="dailyData" class="row mt-4 no-gutters">
          <div class="col-lg-3 col-md-6 col-xs-6">
            <div class="rad-info-box-colored rad-bg-dark-blue1 rad-txt-white">
              <i class="el-icon-document"></i>
              <span class="heading">Today's Sales</span>
              <span class="value"
                ><span>{{
                  // (+dailyData.sales.toFixed(2)).toLocaleString()
                  salesToday.toFixed(2).toLocaleString()
                }}</span></span
              >
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-xs-6">
            <div class="rad-info-box-colored rad-bg-dark-blue1 rad-txt-white">
              <i class="el-icon-money"></i>
              <span class="heading">Today's Expenses</span>
              <span class="value"
                ><span>{{
                  (+dailyData.expenses.toFixed(2)).toLocaleString()
                }}</span></span
              >
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-xs-6 text-center">
            <div class="rad-info-box-colored rad-bg-dark-blue1 rad-txt-white">
              <i class="el-icon-s-marketing"></i>
              <span class="heading">Today's Net Profit</span>
              <span class="value"
                ><span>{{
                  // (+(dailyData.profit - dailyData.expenses).toFixed(
                  //   2
                  // )).toLocaleString()
                  (profitToday - dailyData.expenses).toFixed(2).toLocaleString()
                }}</span></span
              >
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-xs-6">
            <div class="rad-info-box-colored rad-bg-dark-blue1 rad-txt-white">
              <i class="el-icon-remove-outline"></i>
              <span class="heading">Today's Due</span>
              <span class="value"
                ><span>{{
                  (+dailyData.due.toFixed(2)).toLocaleString()
                }}</span></span
              >
            </div>
          </div>
        </div>

        <div v-if="reportData" class="row no-gutters">
          <div class="col-lg-3 col-md-6 col-xs-6">
            <div class="rad-info-box-colored rad-bg-dark-blue rad-txt-white">
              <i class="el-icon-document"></i>
              <span class="heading">Monthly Sales</span>
              <span class="value"
                ><span>{{
                  (+reportData.totalSales.toFixed(2)).toLocaleString()
                }}</span></span
              >
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-xs-6">
            <div class="rad-info-box-colored rad-bg-dark-blue rad-txt-white">
              <i class="el-icon-money"></i>
              <span class="heading">Monthly Expenses</span>
              <span class="value"
                ><span>{{
                  (+reportData.totalExp.toFixed(2)).toLocaleString()
                }}</span></span
              >
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-xs-6 text-center">
            <div class="rad-info-box-colored rad-bg-dark-blue rad-txt-white">
              <i class="el-icon-s-marketing"></i>
              <span class="heading">Monthly Net Profit</span>
              <span class="value"
                ><span>{{
                  (+(reportData.totalProfit - reportData.totalExp).toFixed(
                    2
                  )).toLocaleString()
                }}</span></span
              >
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-xs-6">
            <div class="rad-info-box-colored rad-bg-dark-blue rad-txt-white">
              <i class="el-icon-remove-outline"></i>
              <span class="heading">Monthly Due</span>
              <span class="value"
                ><span>{{
                  (+reportData.totalRemaining.toFixed(2)).toLocaleString()
                }}</span></span
              >
            </div>
          </div>
        </div>

        <div v-if="storeData" class="row mb-4 no-gutters">
          <div class="col-lg-3 col-md-6 col-xs-6">
            <div class="rad-info-box-colored rad-bg-dark-blue2 rad-txt-white">
              <i class="el-icon-document"></i>
              <span class="heading">Total Sales</span>
              <span class="value"
                ><span>{{
                  (+storeData.netPay.toFixed(2)).toLocaleString()
                }}</span></span
              >
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-xs-6">
            <div class="rad-info-box-colored rad-bg-dark-blue2 rad-txt-white">
              <i class="el-icon-money"></i>
              <span class="heading">Total Expenses</span>
              <span class="value"
                ><span>{{
                  (+storeData.totalExp.toFixed(2)).toLocaleString()
                }}</span></span
              >
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-xs-6 text-center">
            <div class="rad-info-box-colored rad-bg-dark-blue2 rad-txt-white">
              <i class="el-icon-s-marketing"></i>
              <span class="heading">Total Net Profit</span>
              <span class="value"
                ><span>{{
                  (+(storeData.totalProfit - storeData.totalExp).toFixed(
                    2
                  )).toLocaleString()
                }}</span></span
              >
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-xs-6">
            <div class="rad-info-box-colored rad-bg-dark-blue2 rad-txt-white">
              <i class="el-icon-remove-outline"></i>
              <span class="heading">Total Due</span>
              <span class="value"
                ><span>{{
                  (+storeData.totalRemain.toFixed(2)).toLocaleString()
                }}</span></span
              >
            </div>
          </div>
        </div>

        <div class="row mt-4 no-gutters">
          <div
            class="col-lg-3 col-md-6 col-xs-6"
            
          >
            <div class="rad-info-box rad-txt-violet">
              <i class="el-icon-discount"></i>
              <span class="heading">Products</span>
              <span class="value"
                ><span>{{ curProducts }}</span></span
              >
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-xs-6">
            <div class="rad-info-box rad-txt-violet">
              <i class="fa fa-truck"></i>
              <span class="heading">Orders</span>
              <span class="value"
                ><span>{{ orders }}</span></span
              >
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-xs-6">
            <div class="rad-info-box rad-txt-primary">
              <i class="fa fa-users"></i>
              <span class="heading">Customers</span>
              <span class="value"
                ><span>{{ cus }}</span></span
              >
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-xs-6">
            <div class="rad-info-box rad-txt-primary">
              <i class="fa fa-shopping-bag"></i>
              <span class="heading">Offers</span>
              <span class="value"
                ><span>{{ curOffers }}</span></span
              >
            </div>
          </div>

          <!-- <div class="col-lg-6 col-xs-6">
            <div class="rad-info-box rad-txt-danger">
              <i class="fa fa-product-hunt"></i>
              <span class="heading">Maximum Items</span>
              <span class="value"
                ><span v-if="plan != 'Starter'">Unlimited</span>
                <span v-if="plan == 'Starter'">40</span></span
              >
            </div>
          </div>
          <div class="col-lg-6 col-xs-6">
            <div class="rad-info-box rad-txt-danger">
              <i class="fa fa-shopping-bag"></i>
              <span class="heading">Maximum Offers</span>
              <span class="value"
                ><span v-if="plan == 'Starter'">10</span
                ><span v-if="plan != 'Starter'">20</span></span
              >
            </div>
          </div> -->
        </div>

        <el-card shadow="always" style="background-color: #dcdfe6" class="my-4">
          <h5 class="mb-3" style="text-align: center">Today's Invoices</h5>
          <b-row>
            <b-col sm="4" class="my-1">
              <b-form-group label="" class="mb-0">
                <b-input-group>
                  <b-form-input v-model="filter" placeholder="Search" />
                  <b-input-group-append>
                    <b-btn :disabled="!filter" @click="filter = ''"
                      >Clear</b-btn
                    >
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col sm="5" class="my-1">
              <b-form-group label="" class="mb-0">
                <b-input-group>
                  <b-form-select v-model="sortBy" :options="sortOptions">
                    <option slot="first" :value="null">Sort By</option>
                  </b-form-select>
                  <b-form-select
                    :disabled="!sortBy"
                    v-model="sortDesc"
                    slot="append"
                  >
                    <option :value="false">Asc</option>
                    <option :value="true">Desc</option>
                  </b-form-select>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col sm="3" class="my-1">
              <b-form-group horizontal class="mb-0">
                <b-form-select v-model="invoiceperPage">
                  <option disabled>per page</option>
                  <option :value="10">10</option>
                  <option :value="20">20</option>
                  <option :value="40">40</option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>

          <!-- Main table element -->
          <el-card style="overflow-x: scroll;" shadow="always">
            <b-table
              show-empty
              stacked="sm"
              :items="invoiceItems"
              :fields="invoiceFields"
              :hover="true"
              head-variant="dark"
              :current-page="invoicecurrentPage"
              :per-page="invoiceperPage"
              :empty-text="emptyText"
              :filter="filter"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              @filtered="onFiltered"
              class="mt-4"
            >
              <template slot="index" slot-scope="data">
                {{ data.index + 1 }}
              </template>

              <template slot="actions" slot-scope="row">
                <div class="btn-group" role="group" aria-label="Basic example">
                  <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->

                  <a
                    size="sm"
                    @click.stop="row.toggleDetails"
                    class="btn btn-sm btn-info text-white"
                  >
                    View
                  </a>
                  <!-- <a
                  size="sm"
                  @click="open(row.item.id)"
                  class="btn btn-sm btn-danger text-white"
                >
                  Delete
                </a> -->
                </div>
              </template>

              <template slot="row-details" slot-scope="row">
                <b-card>
                  <el-row :gutter="10" style="margin-top: 20px">
                    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                      <el-card
                        class="box-card"
                        style="background-color: #eaf0ff"
                      >
                        <div class="clearfix text item">
                          <span>Gross Amount</span>
                          <span style="float: right; padding: 3px 0"
                            >{{
                              row.item.grossAmount.toLocaleString()
                            }}
                            LKR</span
                          >
                        </div>
                        <div class="clearfix text item">
                          <span>Discount</span>
                          <span style="float: right; padding: 3px 0"
                            >{{ row.item.discount.toLocaleString() }} LKR
                          </span>
                        </div>
                        <div class="clearfix text item">
                          <span>Other Discount</span>
                          <span style="float: right; padding: 3px 0">
                            {{ row.item.otherDiscount.toLocaleString() }}
                            LKR
                          </span>
                        </div>
                        <div class="clearfix text item">
                        <span>Service Charge</span>
                        <span style="float: right; padding: 3px 0">
                          {{ row.item.serviceChargeMode === 'Percentage' ? ((row.item.grossAmount * row.item.sCharge) / 100).toLocaleString() : row.item.sCharge.toLocaleString() }} LKR
                        </span>
                      </div>
                      <div class="clearfix text item">
                        <span>Net Amount</span>
                        <span style="float: right; padding: 3px 0"
                          >{{ row.item.netAmount.toLocaleString() }} LKR</span
                        >
                      </div>
                      <div class="clearfix text item">
                        <span>Tax</span>
                        <span style="float: right; padding: 3px 0">
                          {{ row.item.taxMode === 'Percentage' ? ((row.item.netAmount * row.item.tax) / 100).toLocaleString() : row.item.tax.toLocaleString() }} LKR
                        </span>
                      </div>
                        <!-- <div class="clearfix">
            <span style="color: #000; margin-bottom: 5px">Payment Details</span>
          </div> -->
                        <div class="clearfix text item">
                          <span>Card Payment</span>
                          <span style="float: right; padding: 3px 0">
                            {{ row.item.cardPayment.toLocaleString() }} LKR
                          </span>
                        </div>
                        <div class="clearfix text item">
                          <span>Cash Payment</span>
                          <span style="float: right; padding: 3px 0">
                            {{ row.item.cashPayment.toLocaleString() }} LKR
                          </span>
                        </div>
                        <div class="clearfix text item">
                          <span>Cheque Payment</span>
                          <span style="float: right; padding: 3px 0">
                            {{ row.item.chequePayment.toLocaleString() }} LKR
                          </span>
                        </div>
                        <div class="clearfix text item">
                          <span>Balance</span>
                          <span style="float: right; padding: 3px 0"
                            >{{ row.item.balance.toLocaleString() }} LKR</span
                          >
                        </div>
                      </el-card>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                      <h5 class="text-center text-info my-4">Ordeded Items</h5>
                      <div style="overflow-x: scroll;">
                        <b-table
                          show-empty
                          stacked="sm"
                          :items="row.item.products"
                          :fields="invoiceProductsFields"
                          :hover="true"
                          head-variant="dark"
                          :empty-text="emptyText"
                          :filter="filter"
                          :sort-by.sync="sortBy"
                          :sort-desc.sync="sortDesc"
                          
                          class="mt-4"
                        >
                          <template slot="index" slot-scope="data">
                            {{ data.index + 1 }}
                          </template>
                        </b-table>
                      </div>
                    </el-col>
                  </el-row>
                </b-card>
              </template>
            </b-table>
          </el-card>

          <!-- <b-col md="3" class="my-1">
            <b-form-group label="" class="mb-0">
              <b-form-select v-model="invoiceperPage">
                <option disabled>per page</option>
                <option :value="10">10</option>
                <option :value="20">20</option>
                <option :value="40">40</option>
              </b-form-select>
            </b-form-group>
          </b-col> -->
          <b-col md="6" class="my-1">
            <b-pagination
              :total-rows="invoicetotalRows"
              :per-page="invoiceperPage"
              v-model="invoicecurrentPage"
              class="my-0"
            />
          </b-col>
        </el-card>

        <el-card shadow="always" style="background-color: #dcdfe6" class="my-4">
          <h5 class="mb-3" style="text-align: center">Products Low in Stock</h5>
          <b-row>
            <b-col sm="4" class="my-1">
              <b-form-group label="" class="mb-0">
                <b-input-group>
                  <b-form-input v-model="filterLowItem" placeholder="Search" />
                  <b-input-group-append>
                    <b-btn :disabled="!filter" @click="filter = ''"
                      >Clear</b-btn
                    >
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col sm="5" class="my-1">
              <b-form-group label="" class="mb-0">
                <b-input-group>
                  <b-form-select
                    v-model="sortBy"
                    :options="lowItemssortOptions"
                  >
                    <option slot="first" :value="null">Sort By</option>
                  </b-form-select>
                  <b-form-select
                    :disabled="!sortBy"
                    v-model="sortDesc"
                    slot="append"
                  >
                    <option :value="false">Asc</option>
                    <option :value="true">Desc</option>
                  </b-form-select>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col sm="3" class="my-1">
              <b-form-group horizontal class="mb-0">
                <b-form-select v-model="lowItemsperPage">
                  <option disabled>per page</option>
                  <option :value="10">10</option>
                  <option :value="20">20</option>
                  <option :value="40">40</option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>

          <!-- Main table element -->
          <el-card style="overflow-x: scroll;" shadow="always">
            <b-table
              show-empty
              stacked="sm"
              :items="lowStockItems"
              :fields="lowItemsFields"
              :hover="true"
              head-variant="dark"
              :current-page="lowItemscurrentPage"
              :per-page="lowItemsperPage"
              :empty-text="lowStockEmptyText"
              :filter="filterLowItem"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              @filtered="onFiltered"
              class="mt-4"
            >
              <template slot="index" slot-scope="data">
                {{ data.index + 1 }}
              </template>
            </b-table>
          </el-card>

          <b-col md="6" class="my-1">
            <b-pagination
              :total-rows="lowItemstotalRows"
              :per-page="lowItemsperPage"
              v-model="lowItemscurrentPage"
              class="my-0"
            />
          </b-col>
        </el-card>

        <el-card style="background-color: #dcdfe6; overflow-x: scroll;" >
          <h5 class="mb-3" style="text-align: center">New Orders</h5>
          <b-row>
            <b-col sm="5" class="my-1">
              <b-form-group label="" class="mb-0">
                <b-input-group>
                  <b-form-select v-model="sortBy" :options="ordersSortOptions">
                    <option slot="first" :value="null">Sort By</option>
                  </b-form-select>
                  <b-form-select
                    :disabled="!sortBy"
                    v-model="sortDesc"
                    slot="append"
                  >
                    <option :value="false">Asc</option>
                    <option :value="true">Desc</option>
                  </b-form-select>
                </b-input-group>
              </b-form-group>
            </b-col>

            <b-col sm="3" class="my-1">
              <b-form-group horizontal class="mb-0">
                <b-form-select v-model="ordersperPage">
                  <option disabled>per page</option>
                  <option :value="10">10</option>
                  <option :value="20">20</option>
                  <option :value="40">40</option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>

          <!-- Main table element -->
          <b-table
            show-empty
            stacked="sm"
            :items="ordersItems"
            :fields="ordersFields"
            :hover="true"
            head-variant="dark"
            :current-page="orderscurrentPage"
            :per-page="ordersperPage"
            :empty-text="emptyText"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            @filtered="onFiltered"
            style="overflow-x: scroll;"
            class="mt-4"
          >
            <template slot="index" slot-scope="data">
              {{ data.index + 1 }}
            </template>
            <template slot="name" slot-scope="row">
              <b-media>
                <b-img
                  slot="aside"
                  src="https://lorempixel.com/125/125/technics/8/"
                  width="64"
                  height="64"
                  alt="image"
                />
                <h6 class="mt-4">{{ row.value }}</h6>
              </b-media>
            </template>
            <template slot="category" slot-scope="row" class="mt-4">
              <div class="row mt-4">{{ row.value }}</div>
            </template>

            <template slot="status" slot-scope="row">
              <el-select
                v-model="row.item.status"
                @change="upOrder(row.item.id, row.item.status, row.item.refid)"
                size="mini"
                style="width: 160px"
                placeholder="Order Status"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </template>

            <template slot="actions" slot-scope="row">
              <div class="btn-group" role="group" aria-label="Basic example">
                <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->

                <a
                  size="sm"
                  @click.stop="row.toggleDetails"
                  class="btn btn-sm btn-info text-white"
                >
                  View
                </a>
                <router-link
                  v-if="row.item.orderNo"
                  :to="{
                    name: 'createinvoice',
                    query: { order: row.item.orderNo, },
                  }"
                  class="btn btn-sm btn-primary text-white"
                >
                  Invoice
                </router-link>
                <a
                  size="sm"
                  @click="$root.$emit('orderPrint', row.item)"
                  class="btn btn-sm btn-secondary text-white"
                >
                  Print
                </a>
                <!-- <a
                size="sm"
                @click="open(row.item.id)"
                class="btn btn-sm btn-danger text-white"
              >
                Delete
              </a> -->
              </div>
            </template>

            <template slot="row-details" slot-scope="row">
              <b-card>
                <ul>
                  <!-- <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value}}</li> -->
                  <!-- <template class="" v-for="(item, key) in row.item" >
              <div :key="key"> -->
                  <h5 class="text-center text-info">Customer Details</h5>
                  <li class="my-1 mr-2">
                    Customer Name:
                    <span class="ml-2">{{ row.item.cusname }}</span>
                  </li>
                  <li class="my-1 mr-2">
                    Email: <span class="ml-2">{{ row.item.cusemail }}</span>
                  </li>
                  <li class="my-1 mr-2">
                    Telephone: <span class="ml-2">0{{ row.item.telno }}</span>
                  </li>
                  <li class="my-1 mr-2">
                    Address: <span class="ml-2">{{ row.item.address }}</span>
                  </li>
                  <li class="my-1 mr-2">
                    Cart Total Rs:
                    <span class="ml-2">{{ row.item.total }}</span>
                  </li>
                  <!-- </div>
            </template> -->
                </ul>
                <h5 class="text-center text-info my-4">Ordeded Items</h5>
                <div class="row">
                  <template class="" v-for="(item, key) in row.item.products">
                    <div class="col-12 col-sm-4 col-lg-3" style="" :key="key">
                      <img class="card-img-top" :src="item.image" alt="image" />
                      <ul class="list-group list-group-flush">
                        <li class="list-group-item">{{ item.name }}</li>
                        <li class="list-group-item">
                          <span>Rs</span> {{ item.price }}
                        </li>
                        <li class="list-group-item">
                          <span>Quantity</span> {{ item.quantity }}
                        </li>
                        <li class="list-group-item">
                          <span>Total Rs</span> {{ item.subTotal }}
                        </li>
                      </ul>
                    </div>
                  </template>
                </div>
              </b-card>
            </template>
          </b-table>
          <b-col md="6" class="my-1">
            <b-pagination
              :total-rows="orderstotalRows"
              :per-page="ordersperPage"
              v-model="orderscurrentPage"
              class="my-0"
            />
          </b-col>
        </el-card>

        <!-- <h2 v-if="plan != 'Starter'" class="m-auto text-info text-center pt-4 pb-2">Categories</h2>
  <div class="row mt-4 mx-auto" v-if="plan != 'Starter'">
		<div class=" col-12 col-md-6 mx-auto mb-m-7">
      <chartjs-doughnut class="mx-auto" v-if="showchart" :scalesdisplay="false" :width="width" :height="height" :labels="mylabels"
      :datasets="mydatasets"></chartjs-doughnut>
		</div>
  </div>   -->
      </div>
      <OrderPrint style="display: none;" />
      <!-- <div>
        <button @click="createInvoice">Create Invoice</button>
        <button @click="downloadInvoice">Download Invoice</button>
        <button @click="renderInvoice">Render Invoice</button>
      </div> -->
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import db from "../../config/FirebaseInit";
import easyinvoice from "easyinvoice";
import BarChart from "../Charts/BarChart.vue";
import OrderPrint from './InvoiceTemplates/OrderPrint.vue'
import shops from "../../data/shops";
// import Vue from "vue";
// import "hchs-vue-charts";
// import "chart.js";
export default {
  name: "dashboard",
  components: {
    BarChart,
    OrderPrint
  },
  data() {
    return {
      shops: [],
      plan: "",
      cat: "",
      items: "",
      curProducts: "",
      maxProducts: "",
      curOffers: "",
      visits: "",
      orders: "",
      cus: "",
      invoices: 0,
      totalSales: 0,
      totalDue: 0,
      salesToday: 0,
      profitToday: 0,
      showchart: false,
      loading: false,
      changed: true,
      width: 300,
      height: 400,
      mylabels: [],
      mydata: [],
      offset: 4,
      emptyText: "Loading Records...",
      lowStockEmptyText: "No Records",
      invoiceItems: [],
      invoicecurrentPage: 1,
      invoiceperPage: 10,
      invoicetotalRows: 0,
      pageOptions: ["Per Page", 5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      filterLowItem: null,
      storeData: null,
      reportData: null,
      dailyData: null,
      lowItemscurrentPage: 1,
      lowItemsperPage: 10,
      lowStockItems: [],
      lowItemstotalRows: 0,
      lowItemsFields: [
        { key: "store", label: "Store", sortable: true },
        { key: "name", label: "Name", sortable: true },
        { key: "barcode", label: "Barcode", sortable: true },
        { key: "purcPr", label: "Purchased Price", sortable: true },
        { key: "qty", label: "Quantity", sortable: true },
      ],
      invoiceFields: [
        "index",
        //  { key: 'id', label: 'Order id', sortable: true },
        { key: "date", label: "Date", sortable: true },
        { key: "invoiceNo", label: "Invoice No", sortable: true },
        // { key: "storeLocation", label: "Store" },
        { key: "customer", label: "Customer", sortable: true },
        { key: "netAmount", label: "Net Amount", sortable: true },
        { key: "actions", label: "Actions" },
      ],
      invoiceProductsFields: [
        "index",
        { key: "name", label: "Name", sortable: true },
        { key: "barcode", label: "Barcode", sortable: true },
        { key: "category", label: "Category", sortable: true },
        { key: "subcategory", label: "Sub Category", sortable: true },
        { key: "quantity", label: "Quantity", sortable: true },
        { key: "price", label: "Price", sortable: true },
        { key: "discount", label: "Discount", sortable: true },
        { key: "subTotal", label: "Sub Total", sortable: true },
      ],

      ordersItems: [],
      ordersFields: [
        "index",
         { key: 'orderNo', label: 'Order No', sortable: true },
        { key: "cusname", label: "Customer", sortable: true },
        { key: "date", label: "Date", sortable: true },
        { key: "cusemail", label: "Email", sortable: true },
        { key: "telno", label: "Tel No" },
        { key: "total", label: "Total (RS)", sortable: true },
        { key: "status", label: "Status", sortable: true },
        { key: "actions", label: "Actions" },
      ],
      options: [
        {
          value: "Pending",
          label: "Pending",
        },
        {
          value: "Processing",
          label: "Processing",
        },
        {
          value: "Completed",
          label: "Completed",
        },
        {
          value: "Cancelled",
          label: "Cancelled",
        },
      ],
      orderscurrentPage: 1,
      ordersperPage: 10,
      orderstotalRows: 0,

      mydatasets: [
        {
          data: [],
          backgroundColor: [
            "#04B404",
            "#FF8000",
            "#FA5858",
            "#FA5882",
            "#F781BE",
            "#2E9AFE",
            "#FF0040",
            "#A901DB",
            "#81F781",
            "#FF00BF",
            "#2EFEF7",
            "#0101DF",
            "#80FF00",
            "#B40404",
            "#81DAF5",
            "#FF6384",
            "#36A2EB",
            "#FFCE56",
          ],
          hoverBackgroundColor: [
            "#D8D8D8",
            "#D8D8D8",
            "#D8D8D8",
            "#D8D8D8",
            "#D8D8D8",
            "#D8D8D8",
            "#D8D8D8",
            "#D8D8D8",
            "#D8D8D8",
            "#D8D8D8",
            "#D8D8D8",
            "#D8D8D8",
            "#D8D8D8",
            "#D8D8D8",
            "#D8D8D8",
            "#D8D8D8",
            "#D8D8D8",
            "#D8D8D8",
          ],
        },
      ],
      // new data for pos
    };
  },

  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.invoiceFields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
    lowItemssortOptions() {
      // Create an options list from our fields
      return this.lowItemsFields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
    ordersSortOptions() {
      // Create an options list from our fields
      return this.ordersFields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },
  mounted() {
    this.$root.$on("storeChange", (store) => {
      this.$store.state.selectedStore = store;
      this.loading = true;
      this.changed = false;
      this.getInvoices();
      this.getReport();
      this.getStoreData("update");
      // this.getDailyData();
    });
  },
  created() {
    if (screen.width <= 992) this.offset = 0;
    if (screen.width < 1200 && screen.width > 992) this.offset = 2;
    if (screen.width > 575) {
      (this.width = 250), (this.height = 350);
    }
    this.changed = false;
    this.loading = true;

    this.$store.state.prdNameList.forEach((prd) => {
      if (prd.lowStock && prd.lowStock.length > 0) {
        prd.lowStock.forEach((item) => {
          this.lowStockItems.push({
            name: prd.name,
            barcode: prd.barcode,
            purcPr: item.purcPr,
            qty: item.qty,
            store: this.$store.state.stores.find((str) => str.id == item.store)
              .name,
          });
        });
        this.lowItemstotalRows = this.lowStockItems.length;
      }
    });

    this.getStoreData();
    // this.getDailyData();
    this.getReport();

    this.$store.state.secondaryDatabase
      .collection("shops")
      .where("owner", "==", firebase.auth().currentUser.uid)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = {
            id: doc.id,
            plan: doc.data().plan,
            cat: doc.data().cat,
            curOffers: doc.data().curOffers,
            curProducts: doc.data().curProducts,
            maxProducts: doc.data().maxProducts,
            visits: doc.data().visits,
            orders: doc.data().orders,
            catValues: doc.data().catValues,
            cus: doc.data().cus,
            invoices: doc.data().invo,
            netPay: doc.data().netPay,
            totalRemain: doc.data().totalRemain,
          };
          this.shops.push(data);
          this.orders = this.shops[0].orders;
          this.curProducts = this.shops[0].curProducts;
          this.maxProducts = this.shops[0].maxProducts;
          this.curOffers = this.shops[0].curOffers;
          this.visits = this.shops[0].visits;
          this.cus = this.shops[0].cus;
          this.plan = this.shops[0].plan;
          this.cat = this.shops[0].cat;
          this.invoices = this.shops[0].invoices ? this.shops[0].invoices : 0;
          this.totalSales = this.shops[0].netPay ? this.shops[0].netPay : 0;
          this.totalDue = this.shops[0].totalRemain
            ? this.shops[0].totalRemain
            : 0;
          this.mylabels = Object.keys(this.shops[0].catValues);
          this.mydatasets[0]["data"] = Object.keys(this.shops[0].catValues).map(
            (k) => this.shops[0].catValues[k]
          );
          //console.log('this.mylabels',this.mylabels)
          //console.log('this.mydata',this.mydatasets[0]['data'])
          this.showchart = true;
          //console.log(this.cat)
          if (this.cat == "Vehicles") {
            this.items = 5;
          } else {
            //console.log(this.cat, this.items)
            this.items = 10;
            //console.log(this.cat, this.items)
          }
        });

        this.getInvoices();
        
        const docRef = this.$store.state.secondaryDatabase.collection("orders");
          let firestoreQuery = docRef;
          if(this.$store.state.noDB === true) {
            firestoreQuery = firestoreQuery.where("shopid", "==", firebase.auth().currentUser.uid)
          } 
          firestoreQuery
          // .where("shopid", "==", firebase.auth().currentUser.uid)
          .orderBy("date", "desc")
          .limit(10)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              const data = {
                id: doc.id,
                orderNo: doc.data().orderNo,
                cusname: doc.data().uname,
                telno: doc.data().telno,
                address: doc.data().address,
                date: doc.data().date.toDate().toLocaleString(),
                cusemail: doc.data().uemail,
                products: doc.data().products,
                total: doc.data().total,
                status: doc.data().status,
                refid: doc.data().refid,
              };
              this.ordersItems.push(data);
              this.orderstotalRows = this.ordersItems.length;
            });
            if (this.ordersItems.length == 0) {
              this.emptyText = "There are no records to show";
            }
            this.loading = false;
            this.changed = true;
          })
          .catch((error) => alert(error));
      })
      .catch((error) => alert(error));

    // for (let i = 1; i <= 10; i++) {
    //   const dto = {};
    //   this.$store.state.secondaryDatabase
    //     .collection("test")
    //     .doc(`${Math.floor(Math.random() * 10000001).toString()}`)
    //     .set(dto)
    //     .then((doc) => {
    //       if (doc.exists) {
    //         const bytes = sizeof(doc.data());
    //         console.log("size of doc", bytes);
    //       } else {
    //         // doc.data() will be undefined in this case
    //         console.log("No such document!");
    //       }
    //     })
    //     .catch((error) => {
    //       console.log("Error getting document:", error);
    //     });
    // }

    // Pass an options object with `eventBus: true` to receive an eventBus back
    // which emits `start` and `finish` events
  },

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onComplete() {
      this.$router.push("/admin/setting");
    },

    getInvoices() {
      this.invoiceItems = [];
       this.salesToday = 0;
      this.profitToday = 0;
      const start = new Date();
      start.setHours(0, 0, 0, 0);
      // console.log(start);

      const end = new Date();
      end.setHours(23, 59, 59, 999);
      // console.log(end);
      this.$store.state.secondaryDatabase
        .collection("invoices")
        .where("date", ">=", firebase.firestore.Timestamp.fromDate(start))
        .where("date", "<=", firebase.firestore.Timestamp.fromDate(end))
        .where("storeLocation", "==", this.$store.state.selectedStore)
        .orderBy("date", "desc")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const data = {
              id: doc.id,
              products: doc.data().products,
              date: doc.data().date.toDate().toLocaleString(),
              invoiceNo: doc.data().invoiceNo,
              storeLocation: doc.data().storeLocation,
              cashier: doc.data().cashier,
              customer: doc.data().customer,
              customerMobile: doc.data().customerMobile,
              grossAmount: doc.data().grossAmount,
              discount: doc.data().discount,
              otherDiscount: doc.data().otherDiscount,
              tax: doc.data().tax,
              sCharge: doc.data().sCharge,
              taxMode: doc.data().taxMode || "Percentage",
              serviceChargeMode: doc.data().serviceChargeMode || "Percentage",
              netAmount: doc.data().netAmount,
              cardPayment: doc.data().cardPayment,
              cashPayment: doc.data().cashPayment,
              chequePayment: doc.data().chequePayment,
              balance: doc.data().balance,
              profit: doc.data().profit,
            };
            this.salesToday += data.netAmount;
            this.profitToday += data.profit;
            this.invoiceItems.push(data);
            this.invoicetotalRows = this.invoiceItems.length;
          });
          if (this.invoiceItems.length == 0) {
            this.emptyText = "There are no records to show";
          }
        })
        .catch((error) => alert(error));
    },

    getStoreData(update) {
      if (this.$store.state.selectedStore) {
        // when initial project creation & login no store is available
        this.storeData = null;
        this.dailyData = null;
        this.$store.state.secondaryDatabase
          .collection("stores")
          .doc(this.$store.state.selectedStore)
          .get()
          .then((doc) => {
            this.storeData = doc.data();
            const dailyData = doc.data().dailyData;
            if (
              dailyData &&
              dailyData.date == new Date().toLocaleDateString()
            ) {
              this.dailyData = dailyData;
              console.log("dailyData", dailyData);
            } else {
              const dailyData = {
                date: new Date().toLocaleDateString(),
                sales: 0,
                expenses: 0,
                profit: 0,
                due: 0,
              };
              this.dailyData = dailyData;
            }
            if (update) {
              this.loading = false;
              this.changed = true;
            }
            // console.log("doc is", doc);
          })
          .catch((error) => alert(error));
      }
    },

    // getDailyData() {
    //   const itemKey = `dailyData-${this.$store.state.selectedStore}`;
    //   const dailyData = JSON.parse(localStorage.getItem(itemKey));
    //   if (dailyData && dailyData.date == new Date().toLocaleDateString()) {
    //     this.dailyData = dailyData;
    //     console.log("dailyData", dailyData);
    //   } else {
    //     const dailyData = {
    //       date: new Date().toLocaleDateString(),
    //       sales: 0,
    //       expenses: 0,
    //       profit: 0,
    //       due: 0,
    //     };
    //     this.dailyData = dailyData;
    //     localStorage.setItem(itemKey, JSON.stringify(dailyData));
    //   }
    // },

    getReport() {
      this.reportData = null;
      const date = new Date();
      const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 1);
      this.$store.state.secondaryDatabase
        .collection("reports")
        .where("date", ">=", firebase.firestore.Timestamp.fromDate(firstDay))
        .where("date", "<=", firebase.firestore.Timestamp.fromDate(lastDay))
        .where("storeLocation", "==", this.$store.state.selectedStore)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.reportData = doc.data();
          });
        })
        .catch((error) => alert(error));
    },

    open3() {
      this.$notify.info({
        title: "Info",
        message: "Order status is updated",
      });
    },

    upOrder(id, status, refid) {
      this.$store.state.secondaryDatabase
        .collection("orders")
        .doc(id)
        .update({
          status: status,
        })
        .then(() => {
          this.open3();
          if(!this.$store.state.noDB) {
            db.collection("orders")
              .doc(refid)
              .update({
                status: status,
              })
              .then(() => {})
              .catch((error) => alert(error));
          }
        })
        .catch((error) => alert(error));
    },

    async createInvoice() {
      // See documentation for all data properties
      const data = this.getSampleData();
      const result = await easyinvoice.createInvoice(data);
      this.invoiceBase64 = result.pdf;
    },
    async downloadInvoice() {
      // See documentation for all data properties
      const data = this.getSampleData();
      const result = await easyinvoice.createInvoice(data);
      easyinvoice.download("myInvoice.pdf", result.pdf);
      //	you can download like this as well:
      //	easyinvoice.download();
      //	easyinvoice.download('myInvoice.pdf');
    },
    async renderInvoice() {
      // See documentation for all data properties
      document.getElementById("pdf").innerHTML = "loading...";
      const data = this.getSampleData();
      const result = await easyinvoice.createInvoice(data);
      easyinvoice.render("pdf", result.pdf);
    },
    getSampleData() {
      return this.sampleData;
    },
  },
};
</script>

<style scoped>
@import url("~@/assets/admin/css/admin-loader.css");
.el-tag + .el-tag {
  margin-left: 10px;
  margin-top: 5px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.text {
  font-size: 14px;
}
.item {
  margin-bottom: 15px;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}

.box-card {
  width: 400px;
}
/* above are pos new css */

.rad-info-box {
  margin-bottom: 16px;
  box-shadow: 1px 1px 2px 0 #cccccc;
  padding: 20px;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
  background: #fff5d9 !important;
}
.rad-info-box-colored {
  margin-bottom: 16px;
  box-shadow: 1px 1px 2px 0 #cccccc;
  padding: 20px;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
}
.rad-info-box i,
.rad-info-box-colored i {
  display: block;
  background-clip: padding-box;
  margin-right: 15px;
  height: 60px;
  width: 60px;
  border-radius: 100%;
  line-height: 60px;
  text-align: center;
  font-size: 3.4em;
  position: absolute;
}

.rad-info-box .value,
.rad-info-box .heading {
  display: block;
  position: relative;
  color: #515d6e;
  text-align: right;
  z-index: 10;
}

.rad-info-box-colored .value,
.rad-info-box-colored .heading {
  display: block;
  position: relative;
  color: #fbfdff;
  text-align: right;
  z-index: 10;
}

.rad-info-box .heading,
.rad-info-box-colored .heading {
  font-size: 1em;
  font-weight: 300;
  text-transform: uppercase;
}

.rad-info-box .value,
.rad-info-box-colored .value {
  font-size: 2.1em;
  font-weight: 600;
  margin-top: 5px;
}

.rad-txt-white {
  color: #e4e7ed;
}

.rad-txt-primary {
  color: #1c7ebb;
}

.rad-bg-primary {
  background: #1c7ebb !important;
}

.rad-txt-success {
  color: #23ae89;
}

.rad-bg-success {
  background: #23ae89 !important;
}

.rad-txt-danger {
  color: #e94b3b;
}

.rad-bg-danger {
  background: #e94b3b !important;
}

.rad-txt-warning {
  color: #f98e33;
}

.rad-bg-warning {
  background: #f98e33 !important;
}

.rad-txt-violet {
  color: #6a55c2;
}

.rad-bg-violet {
  background: #6a55c2 !important;
}
.rad-bg-dark-blue {
  background: #010a50 !important;
}
.rad-bg-dark-blue1 {
  background: #0d2f69 !important;
}
.rad-bg-dark-blue2 {
  background: #062853 !important;
}
@media (max-width: 575px) {
  .mb-m-7 {
    margin-left: -7px !important ;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/admin/Dashboard.vue